module.exports = __webpack_public_path__ + "static/media/loading.e68700db.svg";